<template>
    <section class="register-appointment">
      <div class="comment-box-container container">

        <div class="comment-box-appointment">
            <h3>Afspraak maken</h3>
            <iframe class="register-frame-form" src="https://internetagenda.vertimart.nl/?id=990236" width="100%" height="700px" frameborder="0"></iframe>
           <!-- <h3>Schrijf je nu in!</h3> -->    
        </div>

     </div>


     </section>
</template>

<script>
// import DatePicker from "@/components/DatePicker.vue";
// import DentalCleaningDropdown from "@/components/DentalCleaningDropdown.vue";
// import HowDidYouFindUsDropdown from "@/components/HowDidYouFindUsDropdown.vue";
// import emailjs from '@emailjs/browser';



export default {
name: "RegisterAppointment",
components: {
    // DatePicker,
    // DentalCleaningDropdown,
    // HowDidYouFindUsDropdown
},
data() {

  }
}
</script>

<style scoped>
/* .contact form {
  border-radius: .5rem;
  background-color: var(--light-bg);
  padding: 2rem;
  margin: 0 auto;
  max-width: 50rem;
}
.contact form .message {
  margin-bottom: 2rem;
  border-radius: .5rem;
  background-color: var(--blue);
  padding: 1.2rem 1rem;
  font-size: 1.7rem;
  color: var(--white);
  text-align: center;
}
.contact form .box {
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 2rem;
  border-radius: .5rem;
  background-color: var(--white);
  padding: 1.2rem 1.4rem;
  font-size: 1.7rem;
  color: var(--black);
  text-transform: none;
}
.contact form span {
  font-size: 1.5rem;
  color: var(--black);
} */

.register-appointment {
    /* background-color: red; */
    /* padding: 0; */
    /* padding-top: 0px; */
    /* margin-top: -30px; */
}

.comment-box-container {
    /* background-color: pink; */
    /* margin: 80px auto; */
}
.comment-box-container h3 {
    /* background-color: red; */
    font-size: 28px;
    text-align: center;
}
.comment-box-appointment {
    border: 1px solid #ccc;
    padding: 20px 20px;
    /* max-width: 500px; */
    /* width: 50%; */
    margin: auto;
    margin-top: 30px;
}
.comment-box-appointment h3{
    color: #F59F16;
    /* background-color: red; */
    padding-top: 20px;
}
.comment-box {
    border: 1px solid #ccc;
    padding: 20px 20px;
    /* max-width: 500px; */
    /* width: 50%; */
    margin: auto;
}
.comment-box h3 {
    font-size: 20px;
    margin-bottom: 20px;
}
.comment-box {
    /* background-color: red; */
}
.comment-box .register-frame-form {
    background-color: green !important;
    color: blue !important;
}
.comment-form input, .comment-form textarea {
    width: 100%;
    padding: 10px;
    margin: 15px 0;
    box-sizing: border-box;
    border: none;
    outline: none;
    background: #F0F0F0;
    resize: none;
    font-size: 14px;
}
.comment-form button {
    margin: 25px auto 10px;
    display: block;
}
.error::-webkit-input-placeholder {
    color: red;
}
.date-of-birth-container {
    position: relative;
}
#calendar-icon{
    color: #606060;
    position: absolute;
    bottom: 29px;
    right: 15px;
    cursor: pointer;
    font-size: 15px;
}
.email-field-container {
    position: relative;
}
#email-field-icon{
    color: #606060;
    position: absolute;
    bottom: 27px;
    right: 15px;
    font-size: 15px;
}
/* radio buttons */


/* radio buttons branches and social media allowed */
.radio-btns-branches-container, .radio-btns-socialmedia-container  {
    margin-top: 8px;
    padding-left: 10px;
}
.radio-btns-socialmedia-container {
    /* background-color: pink; */
    margin-top:14px;
}
.radio-btns-branches-container .field-title, .radio-btns-socialmedia-container .field-title {
    text-align: left;
    font-size: 14px;
    margin-bottom: 3px;
    max-width: 400px;
}
.radio-btns-branches, .radio-btns-socialmedia {
    display: flex;
    column-gap: 18px;
    flex-wrap: wrap;
}

.option-container{
     /* background-color: red;  */
    display: flex;
    align-items: center;
    margin-top: -5px;
    margin-bottom: -5px;
}
.option-container input[type='radio'] {
    width: 12px;
    height: 12px;
    background-color: lightblue;
}
.option-container input[type='radio']:hover{
    cursor: pointer;
}
.option-container label {
    padding-left: 10px;
    padding-top: 6px;
    font-size: 13px;
    cursor: pointer;
}
.radio-btns-branches #gender-error {
    font-size: 13.5px;
    color: red;
    display: none;
    align-self: center; 
    margin-left: auto;
    padding-top: 4px;
}


.hero-btn {
    display: inline-block;
    text-decoration: none !important;
    color: #FFFFFF;
    border: 1px solid #FFFFFF;
    padding: 12px 34px;
    font-size: 16px;
    background: transparent;
    position: relative;
    cursor: pointer;
}
.hero-btn:hover {
    border: 1px solid var(--blue);
    background: var(--blue);
    transition: 1s;
}
.red-btn {
    border: 1px solid var(--blue);
    background: transparent;
    color: var(--blue);
    margin-top: 30px;
}
.red-btn:hover {
    color: #FFF;
}

.date-of-birth-container {
    position: relative;
}

.success-message{
    font-size: 14px;
    margin-top: 25px;
    /* padding: 5px; */
    /* background-color: #5cb85c */
}

@media (max-width: 991px) {
  .comment-box-container {
      margin: 20px auto;
  }
  
}

</style>